import events from './events'
import store from 'reducers'
import Actions from './Actions'
import _ from 'lodash'
import { LoadingActions } from 'actions'

export default class VisitActions extends Actions{
    static get target(){
        return 'visits'
    }

    // static fetch(){
    //     LoadingActions.append({appointments: true})
    //     return this.client.organizations.appointments.fetch({
    //         organizationID: store.getState().config.organizationID, 
    //         accountID: store.getState().session.account.id
    //     }).then((response)=>{
    //         let data = _.orderBy(response.data,['startsAt'],['asc']).reduce((acc,item)=>{
    //             acc[item.id] = item
    //             return acc
    //         },{})
    //         LoadingActions.append({appointments: false})
    //         this.set(data)
    //     })
    // }

    // static onAppointmentSelect(value) {
    //     events.trigger('Appointment.appointmentDidSelect', value)
    // }
    
    // static checkAvailability(data) {
    //     events.trigger('Appointment.appointmentCheck', data)
    //     data.raw = store.getState()
    //     return this.client.organizations.appointments.checkAvailability(data)
    // }
    
    static create(data) {
        return this.client.organizations.visits.create(data).then((response)=>{
            this.append(response.data)
            return response
        })
    }
}


// WEBPACK FOOTER //
// ./actions/VisitActions.js